import React, { useState } from "react";

export default function DeleteAccount() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [typed, setTyped] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const validate = () => {
    if (!email.trim()) return "Email is required.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return "Enter a valid email.";
    if (!password) return "Password is required.";
    if (!confirmChecked) return "Please check the confirmation box.";
    return null;
  };

  const handleDelete = async () => {
    const err = validate();
    if (err) {
      setError(err);
      return;
    }

    setError("");
    setMessage("");
    setShowModal(false);

    try {
      const res = await fetch("https://pegiora.com/courier/public/api/customer-delete-account", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email : email, password: password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.data || "Failed to delete account")
      };

      setMessage(data.message || "Account deleted successfully.");
      setShowModal(false);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div style={{ fontFamily: "sans-serif", backgroundColor: "#f9fafb", minHeight: "100vh" }}>
      {/* Header */}
      <header
        style={{
          background: "linear-gradient(to bottom, #0b1b66, #1f2b7a, #3f2a6b)",
          color: "white",
          textAlign: "center",
          padding: "80px 20px",
        }}
      >
        <p style={{ opacity: 0.8, textTransform: "uppercase", letterSpacing: "1px" }}>
          Privacy & Account
        </p>
        <h1
          style={{
            fontSize: "42px",
            fontWeight: "bold",
            color: "#d6ff7a",
            margin: "20px 0",
          }}
        >
          Delete Your Account
        </h1>
        <p
          style={{
            maxWidth: "700px",
            margin: "0 auto",
            opacity: 0.8,
            fontSize: "16px",
            lineHeight: "1.6",
          }}
        >
          Deleting your account will permanently remove your profile and all data. This action cannot be undone.
          Please confirm your email, password and check the confirmation box before continuing.
        </p>
      </header>

      {/* Form Section */}
      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          marginTop: "-40px",
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "40px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "20px" }}>
          Confirm Account Deletion
        </h2>

        {error && (
          <div
            style={{
              backgroundColor: "#fee2e2",
              border: "1px solid #fecaca",
              color: "#b91c1c",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          >
            {error}
          </div>
        )}
        {message && (
          <div
            style={{
              backgroundColor: "#dcfce7",
              border: "1px solid #bbf7d0",
              color: "#166534",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          >
            {message}
          </div>
        )}

        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          <div style={{ flex: "1" }}>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "500" }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
              }}
            />
          </div>
          <div style={{ flex: "1" }}>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "500" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
              }}
            />
          </div>
        </div>

        <div style={{ marginTop: "20px", display: "flex", alignItems: "flex-start", gap: "10px" }}>
          <input
            type="checkbox"
            checked={confirmChecked}
            onChange={(e) => setConfirmChecked(e.target.checked)}
            style={{ marginTop: "4px" }}
          />
          <span style={{ fontSize: "14px" }}>
            I understand this action is <b>permanent</b> and cannot be undone.
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "30px",
          }}
        >
          {/* <button
            onClick={() => {
              setEmail("");
              setPassword("");
              setConfirmChecked(false);
              setError("");
              setMessage("");
            }}
            style={{
              padding: "10px 20px",
              background: "white",
              border: "1px solid #ccc",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Reset
          </button> */}

          <button
            onClick={() => {
               const err = validate();
                if (err) {
                  setError(err);
                  return;
                }
              setShowModal(true);
            }}
            style={{
              padding: "10px 20px",
              backgroundColor: "#dc2626",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            Delete Account
          </button>
        </div>
      </main>

      {/* Confirmation Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "30px",
              width: "400px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            }}
          >
            <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>
              Confirm Permanent Deletion
            </h3>
            <p style={{ fontSize: "14px", color: "#555" }}>
              Type <b>DELETE</b> below to confirm. This action cannot be undone.
            </p>

            <input
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              placeholder="Type DELETE"
              style={{
                width: "100%",
                marginTop: "10px",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "10px" }}>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  background: "white",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (typed.trim() === "DELETE") handleDelete();
                  else setError("You must type DELETE to confirm.");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#b91c1c",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
